import { ChartOverlaysBorder } from '../../core/components/overlays/ChartOverlaysBorder.js';
import { useVisibleAxesScales } from '../hooks/useVisibleAxesScales.js';

export const XYChartAxisBorder = () => {
  const { left, right, bottom, top } = useVisibleAxesScales();

  return (
    <ChartOverlaysBorder
      left={!!left}
      right={!!right}
      bottom={!!bottom}
      top={!!top}
    />
  );
};
